<template>
    <div class="header__top_account_menu_box_sessiontimer">
        remaining session {{ timer }}
    </div>
</template>

<script>

export default {
  name: 'header-top-account-menu-box-sessiontimer',
  props: {
    timer: {
      type: String
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/layout/header/headertopaccountmenuboxsessiontimer";
</style>
